!function(){function r(r){return r.toString().replace(/\B(?=(\d{3})+(?!\d))/g," ")}function o(o){$("#chart-countries").vectorMap({map:"world_mill",backgroundColor:"#ffffff",zoomOnScroll:!1,regionStyle:{initial:{fill:"#aaaaaa"}},series:{regions:[{values:o.data,scale:["#FFAAAA","#EE1111"],normalizeFunction:"polynomial"}]},onRegionTipShow:function(e,a,t){a.html(CountriesList[t]+" ("+(o.data[t]?r(o.data[t]):0)+")")}})}function e(r){if(this.element=document.getElementById(r.id),this.options=r.options||{},this.options.scales={yAxes:[{display:!0,ticks:{beginAtZero:!0}}]},r.isPercents&&(this.options.scales.yAxes[0].ticks.max=100),r.legend?this.options.legend={position:r.legend}:this.options.legend={display:!1},r.title&&(this.options.title={display:!0,position:"top",fontStyle:"normal",text:r.title}),"bar"!=r.type&&"pie"!=r.type||(r.data=[{data:r.data}]),r.palette&&t[r.palette])switch(r.type){case"line":r.data=this.paletteLine(t[r.palette],r.data);break;case"bar":r.data=this.paletteBar(t[r.palette],r.data);break;case"pie":r.data=this.palettePie(t[r.palette],r.data)}this.obj=new Chart(this.element,{type:r.type,options:this.options,data:{labels:r.labels,datasets:r.data}})}function a(r){this.charts=[],this.init(r||[])}var t={primary:[{background:"#205081",border:"#104071"},{background:"#d04437",border:"#c03427"},{background:"#f6c342",border:"#e6b332"},{background:"#14892c",border:"#04791c"},{background:"#707070",border:"#606060"},{background:"#ebf2f9",border:"#dbe2e9"},{background:"#3b73af",border:"#2b639f"},{background:"#333333",border:"#222222"},{background:"#a5a5a5",border:"#959595"}],secondary:[{background:"#3b7fc4",border:"#2b6fb4"},{background:"#ea632b",border:"#da531b"},{background:"#999999",border:"#888888"},{background:"#815b3a",border:"#714b2a"},{background:"#f1a257",border:"#e19247"},{background:"#d39c3f",border:"#d38c2f"},{background:"#4a6785",border:"#3a5775"},{background:"#8eb021",border:"#7ea011"},{background:"#ac707a",border:"#9c606a"},{background:"#654982",border:"#553972"},{background:"#7bc1a1",border:"#6bb191"},{background:"#f15c75",border:"#e14c65"},{background:"#f691b2",border:"#e681a2"},{background:"#205081",border:"#104071"},{background:"#d04437",border:"#c03427"},{background:"#f6c342",border:"#e6b332"},{background:"#14892c",border:"#04791c"}]};e.prototype={paletteLine:function(r,o){for(var e=0;e<o.length;e++)o[e].backgroundColor=r[e].background,o[e].borderColor=r[e].border,o[e].borderWidth=2;return o},paletteBar:function(r,o){o[0].backgroundColor=[],o[0].borderColor=[];for(var e=0,a=0;e<o[0].data.length;e++,a++)r[a]||(a=0),o[0].backgroundColor.push(r[a].background),o[0].borderColor.push(r[a].border);return o},palettePie:function(r,o){o[0].backgroundColor=[],o[0].hoverBackgroundColor=[];for(var e=0,a=0;e<o[0].data.length;e++,a++)r[a]||(a=0),o[0].backgroundColor.push(r[a].background),o[0].hoverBackgroundColor.push(r[a].border);return o}},a.prototype={init:function(r){for(var o=0;o<r.length;o++)this.add(r[o])},add:function(r){"map"==r.type?this.charts.push(new o(r)):this.charts.push(new e(r))}},window.Statistics=a}();
//# sourceMappingURL=cleantalk.min.js.map

window.addEventListener('load', function () {
    var search_ul = $('#search_ul');
    var max_width = window.innerWidth;
    if (max_width <= 560) {
        search_ul.css({width: max_width + 'px'});
    }
    var anchor_links = $('a[href^="#"]');
    anchor_links.each(function (index, element) {
        var id = $(element).attr('href').replace('#', '');
        if (id !== '') {
            $('#' + id).addClass('anchor_target');
        }
    });
    var id_link = window.top.location.hash;
    if (id_link !== '') {
        $('html').animate({
                scrollTop: $(id_link).offset().top
            }, 300
        );
    }

    $('div.code-control a.link-btn').on('click', function(){
        var href = window.location.protocol + '//' + window.location.hostname + window.location.pathname + $(this).attr("href");
        copyToClipboard(href);
        $(this).html('Copied');
    });

    $('#search_icon').on('shown.bs.dropdown', function () {
        $('nav td.gsc-input input').focus();
    });
});

window.addEventListener('scroll', function () {
    document.cookie = 'ct_has_scrolled=1';
});

function copyToClipboard(textToCopy) {
    var textArea;

    function isOS() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.readOnly = true;
        textArea.contentEditable = true;
        textArea.value = text;
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range, selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        } else {
            textArea.select();
        }
    }

    function copyTo() {
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }

    createTextArea(textToCopy);
    selectText();
    copyTo();
}
